/**
 * Window events of the plan-limit UX. Dependency-free so lib/api.js (the
 * central fetch wrapper) and lib/quota.js (the pre-checks) can both emit
 * them without importing each other.
 */
/** Open the plan overlay — detail { feature, code, needed?, remaining?, message?, source } */
export const PLAN_LIMIT_EVENT = 'autonoma:plan-limit';
/** Small non-blocking toast — detail { message, feature?, action?: 'plans' } */
export const QUOTA_TOAST_EVENT = 'autonoma:quota-toast';
/** Usage changed (a job started / a plan changed) — listeners refetch */
export const USAGE_CHANGED_EVENT = 'autonoma:usage-changed';
/** Monthly quota caps (a plan GATE — feature_not_in_plan — keeps the toast). */
export const QUOTA_CAP_CODES = ['quota_exceeded', 'changes_budget_exhausted'];

export function emitQuotaEvent(name, detail = {}) {
  try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch { /* SSR/test safety */ }
}
